import PostbackTestActions from '../../../../actions/PostbackTestActions';


export const actions = {
    visibleModal() {
        PostbackTestActions.visibleModal();
    },

    hiddenModal() {
        PostbackTestActions.hiddenModal();
    },

    testing(id) {
        PostbackTestActions.test({id});
    },

    clear() {
        PostbackTestActions.clear();
    }
};
